import React from 'react'
import starCircle from '../assets/img/star-circle.svg'
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


export const Liquidity = () => {
    const options = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderRadius: 10,
         borderSkipped: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
        font: {
          size: 20,
        },
        color: '#FFFFFFB2',
      },
      },
      y: {
        min: 0,
        max: 1000,
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
      }
    },
  };

  const dataFirst = {
  labels: ["NEO BIT", "b***t"],
  datasets: [
    {
      label: "",
      data: [1000, 1000],
      categoryPercentage: 1,
      backgroundColor: (context) => {
        const chart = context.chart;
        const {ctx, chartArea} = chart;
        
        if (!chartArea) {
          return null;
        }
        
        if(context.dataIndex === 0){
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, '#0284C7');   
            gradient.addColorStop(1, '#3EBDFF');
            return gradient;
        }
        return '#1C2D36'
      },
      borderWidth: 1,
      datalabels: {
        color: '#FFFFFFB2',
        font: {
          size: 20,
        },
        anchor: 'end',
        align: 'start',
        offset: 10,
        formatter: (value, context) => {
            return '23,44M'
        }
      },
    },
  ],
};
 const dataSecond = {
  labels: ["NEO BIT", "b***t"],
  datasets: [
    {
      label: "",
      data: [1000, 500],
      categoryPercentage: 1,
      backgroundColor: (context) => {
        const chart = context.chart;
        const {ctx, chartArea} = chart;
        
        if (!chartArea) {
          return null;
        }
        
        if(context.dataIndex === 0){
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, '#0284C7');   
            gradient.addColorStop(1, '#3EBDFF');
            return gradient;
        }
        return '#1C2D36'
      },
      borderWidth: 1,
      datalabels: {
        color: '#FFFFFFB2',
        font: {
          size: 20,
        },
        anchor: 'end',
        align: 'start',
        offset: 10,
        formatter: (value, context) => {
            return '23,44M'
        }
      },
    },
  ],
};
  return (
    <div id="liquidity">
        <div className="container">
            <div className="liquidity">
                <div className="heading">
                    <h1>Всесторонняя ликвидность</h1>
                    <div className="liquidity-filter">
                        <div className="liquidity-item">BTC</div>
                        <div className="liquidity-item">ETH</div>
                        <div className="liquidity-item">SOL</div>
                        <div className="liquidity-item">XPR</div>
                        <div className="liquidity-item">DOGE</div>
                        <div className="liquidity-item">ADA</div>
                    </div>
                </div>
                <div className="cards">
                    <div className="card">
                        <div className="min-cost-title"><img src={starCircle} alt="" /> Фьючерсы</div>
                        <div className="liquidity-boxes">
                            <div className="liquidity-box">
                                <div className="min-cost-box-txt">
                                    <span>Торгуемый объем (USDT)</span>
                                    <div className="min-cost-perc">2,0x выше аналогичного отраслевого показателя</div>
                                </div>
                                <div className="liquidity-stats">
                                   <Bar options={options} data={dataFirst} plugins={[ChartDataLabels]}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="min-cost-title"><img src={starCircle} alt="" /> Спот</div>
                        <div className="liquidity-boxes">
                            <div className="liquidity-box">
                                <div className="min-cost-box-txt">
                                    <span>Торгуемый объем (USDT)</span>
                                    <div className="min-cost-perc">4,5x выше аналогичного отраслевого показателя</div>
                                </div>
                                <div className="liquidity-stats">
                                    <Bar options={options} data={dataSecond} plugins={[ChartDataLabels]}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
